<template>

<div>
  <!-- 顶部面包屑 -->
  <div class="bread">
    <router-link class="bread-item" to="/">上上签</router-link>
    <div class="bread-arrow">&gt;</div>问题详情
  </div>

  <!-- 问题详情 -->
  <section id="qa-question-detail">
    <div class="qa-question-detail-question">

      <!-- 标题 -->
      <h3>{{questionData.question}}</h3>

      <!-- 描述 -->
      <p :class="{contentExceed: contentExceed}" @click="contentExceed = false">{{questionData.description}}</p>

      <button v-show="contentExceed" @click="contentExceed = !contentExceed">展开全部</button>

      <!-- 国家 -->
      <!-- <div>
        <span v-for="(country, index) in questionData.visa_country_set" :key="index">{{country}}</span>
      </div> -->

      <!-- 标签 -->
      <div class="qa-question-detail-label" v-if="questionData.label && questionData.label.length > 0">
        <span v-for="(item, index) in questionData.label" :key="index">{{item}}</span>
      </div>

    </div>

    <div class="qa-question-detail-answer" v-if="questionData.answers">

      <!-- 答案 -->
      <p v-if="questionData.answers">{{questionData.answers.answer}}</p>

      <!-- 时间 -->
      <div v-if="questionData.answers">{{questionData.answers.update_time}}</div>
    </div>
    <div class="qa-question-detail-like" @click="likeQA()" v-if="questionData.answers">
      <img src="../../assets/imgs/product-detail/detail_like.png" alt="点赞" v-show="!questionData.is_like">
      <img src="../../assets/imgs/product-detail/detail_liked.png" alt="点赞" v-show="questionData.is_like">
      <div class="link-count">{{showLikeCount || 0}}</div>
    </div>

    <!-- 没有回答时 -->
    <div class="qa-question-no-answer" v-if="!questionData.answers">
      <img src="../../assets/imgs/QA/answer_none.png" alt="暂无回答">
      <p>暂无回答</p>
    </div>

  </section>
</div>
</template>

<script>
import { mapMutations } from 'vuex';
import Http from '@/libs/http';
import User from '@/libs/user';

export default {
  name: 'questionDetail',
  data() {
    return {
      params: {
        id: +this.$route.params.id,
      },
      questionData: {},
      contentExceed: false,
    };
  },
  computed: {
    showLikeCount() {
      if (this.questionData.like_count > 999) {
        return '999+';
      }
      return this.questionData.like_count;
    },
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    questioQuery() {
      Http.post('/sys/qa_question_query', {
        qa_question_id: this.params.id,
        peer_account_id: User.peer_account_id ? User.peer_account_id : undefined,
      }).then((data) => {
        this.questionData = data;

        // 页面加载完后获取高度
        this.$nextTick(() => {
          this.textHeight();
        });
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 点赞操作或取消点赞操作
    likeQA() {

      // 如果没有登录，则跳转到登录页面
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'productdetail_question_detail' });
        return;
      }
      Http.post('/qa_question_like', {
        qa_question_id: this.questionData.qa_question_id,
      }).then((data) => {
        this.questionData.is_like = data.is_like;
        this.questionData.like_count = data.like_count;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 判断文字是否超过三行
    textHeight() {
      const textContent = document.querySelector('#qa-question-detail .qa-question-detail-question p');
      if (textContent.clientHeight > 78) {
        this.contentExceed = true;
      } else {
        this.contentExceed = false;
      }
    },
  },
  created() {
    this.questioQuery();
  },
};
</script>

<style lang="less" scoped>
.bread {
  font-size: 12px;
  color: #333333;
  width: 1000px;
  margin: 0 auto;
}

#qa-question-detail {
  width: 1000px;
  margin: 0 auto 60px auto;
  background-color: #ffffff;
  padding: 30px 0;
  .qa-question-detail-question {
    padding: 0 30px 30px 68px;
    position: relative;
    &::after{
      content: "";
      position: absolute;
      left: 68px;
      right: 30px;
      bottom: 0;
      height:1px;
      background:rgba(233,238,242,1);
    }
    &::before{
      content: "";
      position: absolute;
      left: 32px;
      top: 2px;
      width: 30px;
      height: 31px;
      background: url("../../assets/imgs/product-detail/list-question.png") no-repeat center / 100% 100%;
    }

    h3 {
      font-size: 18px;
      line-height: 30px;
      color: #2F333D;
      margin-bottom: 10px;
    }
    p {
      font-size: 16px;
      line-height: 30px;
      color: #5F666E;
      white-space: pre-wrap; // 遇到换行符时换行
    }
    .contentExceed {
      /* 让文本内容只显示三行，超出部分隐藏，结尾省略号 */
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
    button {
      background: #ffffff;
      border: none;
      font-size: 16px;
      color: #5e9be1;
      cursor: pointer;
      padding-top: 20px;
      outline: none;
    }
    .qa-question-detail-label {
      padding-top: 20px;
      span {
        display: inline-block;
        font-size: 14px;
        line-height: 28px;
        color: #aaaaaa;
        background-color: #f3f4f6;
        padding: 0 20px;
        margin-right: 20px;
      }
    }
  }
  .qa-question-detail-answer {
    position: relative;
    padding: 30px 30px 0 68px;
    &::after{
      content: "";
      width: 30px;
      height: 31px;
      background: url("../../assets/imgs/product-detail/detail-answer.png") no-repeat center / 100% 100% ;
      position: absolute;
      left: 32px;
      top: 32px;
    }
    p {
      font-size: 16px;
      line-height: 30px;
      color: #5F666E;
      white-space: pre-wrap; // 遇到换行符时换行
    }
    div {
      font-size: 14px;
      line-height: 14px;
      padding: 24px 0 32px 0;
      color: #91999F;
    }
  }
  .qa-question-detail-like {
    margin: 0 auto;
    width: 84px;
    height: 84px;
    position: relative;
    padding-bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .link-count {
      font-size: 14px;
      line-height: 1;
      color: #fff;
      position: relative;
      z-index: 1;
    }
    &:hover {
      opacity: 0.8;
    }
  }

  .qa-question-no-answer {
    margin: 70px auto 40px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    line-height: 54px;
    color: #6f6f6f;
    img {
      width: 96px;
      height: 90px;
    }
  }
}

</style>





// WEBPACK FOOTER //
// src/pages/product/questionDetail.vue